module.exports = __webpack_public_path__ + "static/media/sx.a4ac1b11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sx.svg
// module id = 256
// module chunks = 0